import { CameraGizmo } from "./CameraGizmo";
import "./CameraGizmoAndZoom.css";
import { CameraZoomButton } from "./CameraZoomButton";

export function CameraGizmoAndZoom() {
  return (
    <div className="camera-gizmo-and-zoom">
      <CameraGizmo />
      <CameraZoomButton direction="out" className="zoom-out-button" />
      <CameraZoomButton direction="in" className="zoom-in-button" />
    </div>
  );
}
